<template>
    <div id="app" class="layout__container colour__background-light-grey">
      <div
        v-if="warningText"
        class="layout__padding-clear layout__width-100 layout__padding-20-0 text__align-center colour__background-pink font__size-20"
      >
        {{ warningText }}
      </div>

        <div class="colour__background-white layout__padding-clear layout__width-80 d-flex flex-col main-screen">
            <div class="layout__width-95 layout__padding-clear">
                <router-link to="/" class="link__colour-black"><img id="component__logo"
                                                                    src="https://rpsassets.blob.core.windows.net/rpsimages/images/logos/rav02.png">
                </router-link>
                <span class="layout__position-right layout__display-block" id="mustlogin">
                    <el-button
                            class="button-red button__base__header layout__position-right layout__margin__top-20 layout__width-170px"
                            id="openLoginClosable" v-on:click="openLoginDialog()">Login / Register</el-button>
                    <div class="component__basket-tab layout__position-right">
                        <router-link to="/basket">
                            <div class="layout__position-right text__size-30 text__colour-teal layout__padding-0-20">
                                <img class="layout__width-30px layout__height-30px"
                                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/shopping-cart.svg"/>
                                <div class="component__basket-icon">
                                    {{getPhotofixrTotal.photofixr.total + getPhotofixrTotal.instantPrint.total + getPhotofixrTotal.directmailr.total}}
                                </div>
                            </div>
                        </router-link>
                    </div>
                </span>

                <div class="layout__position-right layout__display-none" id="alreadyloggedin">

                    <el-button
                            class="layout__width-150px button__background-white button__base__header layout__position-right layout__margin__top-20"
                            v-on:click="logoutUser()">
                        Logout
                    </el-button>
                    <div class="component__basket-tab layout__position-right">
                        <router-link to="/basket">
                            <div class="layout__position-right text__size-30 text__colour-teal layout__padding-0-20">
                                <img class="layout__width-30px layout__height-30px"
                                     src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/shopping-cart.svg"/>
                                <div class="component__basket-icon">
                                    {{getPhotofixrTotal.photofixr.total + getPhotofixrTotal.instantPrint.total + getPhotofixrTotal.directmailr.total}}
                                </div>
                            </div>
                        </router-link>
                    </div>


                    <el-dropdown :hide-on-click="true" id="myAccount"
                                 class="layout__padding__top-20px layout__position-right">
                        <span class="el-dropdown-link">
                            <img class="layout__width-30px layout__height-30px layout__height-30px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/Account.svg"/>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="layout__padding-clear layout__width-200px layout__border__all-1px-grey">
                            <el-dropdown-item>
                                <router-link to="/account/summary" class="link__colour-black">
                                    <p class="component__account__title layout__border__bottom-1px-dotted-cdcfd1">My Account</p>
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/orders/all" class="link__colour-black">
                                    <p class="component__account__title layout__border__bottom-1px-dotted-cdcfd1">My Orders</p>
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/account/invoices" class="link__colour-black">
                                    <p class="component__account__title layout__border__bottom-1px-dotted-cdcfd1">My Invoices</p>
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/account/settings" class="link__colour-black">
                                    <p class="component__account__title layout__border__bottom-1px-dotted-cdcfd1">My Settings</p>
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/directmailr/profile" @click.native="showProfile" class="link__colour-black">
                                    <p class="component__account__title layout__border__bottom-1px-dotted-cdcfd1">My Profile</p>
                                </router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <a href="https://ravensworthprinted.zendesk.com/hc/en-us" target="_blank"
                                   class="link__colour-black">
                                    <div class="component__account__title">Help & Support</div>
                                </a>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <div class="component__navigation-tab layout__position-right" id="admin">

                        <el-dropdown :hide-on-click="true" class="layout__position-left">
                        <span class="el-dropdown-link">
                           <img class="layout__width-30px layout__height-30px layout__padding-0-20"
                                   src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/Admin.svg"/>
                        </span>
                            <el-dropdown-menu slot="dropdown" class="layout__padding-clear layout__width-500px layout__margin__left-minus-40 layout__border__all-1px-grey">

                                <div class="layout__padding-20px">

                                    <div class="layout__width-50 layout__position-left">
                                        <div class="" id="userManagement">
                                            <p class="text__size-18 text__colour-teal layout__padding__left-10px">User
                                                Admin</p>
                                            <el-dropdown-item>
                                                <router-link to="/admin/users" class="link__colour-black">
                                                    <p class="component__admin__title">Search All Users</p>
                                                </router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/admin/users/create" class="link__colour-black">
                                                    <p class="component__admin__title">Create User</p>
                                                </router-link>
                                            </el-dropdown-item>
                                        </div>

                                        <div class="layout__padding-10px-0" id="orders">
                                            <p class="text__size-18 text__colour-teal layout__padding__left-10px">Orders
                                                Admin</p>
                                            <el-dropdown-item>
                                                <router-link to="/admin/customers" class="link__colour-black">
                                                    <p class="component__admin__title">Search All Customers</p>
                                                </router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/admin/orders" class="link__colour-black">
                                                    <p class="component__admin__title">Search All Orders</p>
                                                </router-link>
                                            </el-dropdown-item>
                                            <!--<el-dropdown-item>-->
                                                <!--<router-link to="/admin/orders/bespoke/create"-->
                                                             <!--class="link__colour-black">-->
                                                    <!--<p class="component__admin__title">Create a Bespoke Order</p>-->
                                                <!--</router-link>-->
                                            <!--</el-dropdown-item>-->
                                            <el-dropdown-item>
                                                <router-link to="/admin/orders/bespoke" class="link__colour-black"><p
                                                        class="component__admin__title">Search Bespoke Orders</p>
                                                </router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/admin/orders/email" class="link__colour-black"><p
                                                        class="component__admin__title">Search Email Orders</p>
                                                </router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/admin/invoices" class="link__colour-black"><p
                                                        class="component__admin__title">Invoices</p></router-link>
                                            </el-dropdown-item>
                                        </div>

                                        <div class="layout__padding-10px-0" id="billing">
                                            <!--<p class="text__size-18 text__colour-teal layout__padding__left-10px">-->
                                                <!--Billing Admin</p>-->
                                            <!--<el-dropdown-item>-->
                                                <!--<router-link to="/billing/customers" class="link__colour-black"><p-->
                                                        <!--class="component__admin__title">Search Customers</p>-->
                                                <!--</router-link>-->
                                            <!--</el-dropdown-item>-->
                                            <!--<el-dropdown-item>-->
                                                <!--<router-link to="/billing/customers/create" class="link__colour-black">-->
                                                    <!--<p-->
                                                            <!--class="component__admin__title">Create Customers</p>-->
                                                <!--</router-link>-->
                                            <!--</el-dropdown-item>-->
                                            <!--<el-dropdown-item>-->
                                                <!--<router-link to="/billing/orders" class="link__colour-black"><p-->
                                                        <!--class="component__admin__title">Search Orders</p></router-link>-->
                                            <!--</el-dropdown-item>-->
                                            <!--<el-dropdown-item>-->
                                                <!--<router-link to="/billing/invoices" class="link__colour-black"><p-->
                                                        <!--class="component__admin__title">Invoices</p></router-link>-->
                                            <!--</el-dropdown-item>-->
                                        </div>


                                        <div class="layout__padding-10px-0" id="support">
                                            <p class="text__size-18 text__colour-teal layout__padding__left-10px">Order
                                                Support</p>
                                            <el-dropdown-item>
                                                <router-link to="/photofixr/upload-orders"
                                                             class="link__colour-black"><p
                                                        class="component__admin__title">Upload Photofixr Orders</p>
                                                </router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/photofixr/orders" class="link__colour-black"><p
                                                        class="component__admin__title">Photofixr Orders</p>
                                                </router-link>
                                            </el-dropdown-item>
                                        </div>
                                    </div>

                                    <div class="layout__width-50 layout__position-left">
                                        <div class="layout__padding-10px-0" id="insights">
                                            <p class="text__size-18 text__colour-teal layout__padding__left-10px">Sales
                                                Insights</p>
                                            <el-dropdown-item>
                                                <router-link to="/insights/bespokereports" class="link__colour-black"><p
                                                        class="component__admin__title">Bespoke Reports</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/categorysales" class="link__colour-black"><p
                                                        class="component__admin__title">Category Sales</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/customersales" class="link__colour-black"><p
                                                        class="component__admin__title">Customer Sales</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/customerstatus" class="link__colour-black"><p
                                                        class="component__admin__title">Customer Status</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/lapsedcustomers" class="link__colour-black"><p
                                                        class="component__admin__title">Lapsed Customers</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/monthendtasks" class="link__colour-black"><p
                                                        class="component__admin__title">Month End Tasks</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/newcustomerrevenue" class="link__colour-black"><p
                                                        class="component__admin__title">New Customer Revenue</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/newsales" class="link__colour-black"><p
                                                        class="component__admin__title">New Sales</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/productsales" class="link__colour-black"><p
                                                        class="component__admin__title">Product Sales</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/territorysales" class="link__colour-black"><p
                                                        class="component__admin__title">Territory Sales</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/insights/totalsales" class="link__colour-black"><p
                                                        class="component__admin__title">Total Sales</p></router-link>
                                            </el-dropdown-item>
                                            </div>
                                            <div class="layout__padding-10px-0" id="system">
                                                <p class="text__size-18 text__colour-teal layout__padding__left-10px">System
                                                    Admin</p>
                                            <el-dropdown-item>
                                                <router-link to="/billing/prices/create" class="link__colour-black"><p
                                                        class="component__admin__title">Create Prices</p></router-link>

                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/billing/prices" class="link__colour-black"><p
                                                        class="component__admin__title">Search Prices</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/billing/products/create" class="link__colour-black"><p
                                                        class="component__admin__title">Create Products</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/billing/products" class="link__colour-black"><p
                                                        class="component__admin__title">Search Products</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/directmailr/templates" @click.native="showTemplates" class="link__colour-black"><p
                                                        class="component__admin__title">Directmailr Templates</p></router-link>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <router-link to="/billing/vouchers/dashboard" class="link__colour-black"><p
                                                        class="component__admin__title">Create Voucher Codes</p></router-link>
                                            </el-dropdown-item>
                                        </div>
                                    </div>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <!--<div class="layout__position-right text__size-30 text__colour-teal"><img-->
                                <!--class="layout__width-30px layout__height-30px layout__padding-0-20"-->
                                <!--src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/Admin.svg"/></div>-->
                        <!--<div id="dropdownAdmin">-->
                            <!--<div class="component__columns-2__no-padding layout__position-left layout__border__right-1px-dotted-cdcfd1">-->
                                <!--<div class="layout__padding-0-20">-->
                                    <!--<div class="layout__padding-10px-0" id="userManagement">-->
                                        <!--&lt;!&ndash;<p class="text__size-18 text__colour-teal layout__padding__left-10px">User&ndash;&gt;-->
                                        <!--&lt;!&ndash;Admin</p>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<router-link to="/admin/users" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Search All Users</p></router-link>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<router-link to="/admin/users/create" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Create User</p></router-link>&ndash;&gt;-->
                                    <!--</div>-->
                                    <!--<div class="layout__padding-10px-0" id="orders">-->
                                        <!--<p class="text__size-18 text__colour-teal layout__padding__left-10px">Orders-->
                                            <!--Admin</p>-->
                                        <!--<router-link to="/admin/customers" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Search All Customers</p></router-link>-->
                                        <!--<router-link to="/admin/orders" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Search All Orders</p></router-link>-->
                                        <!--&lt;!&ndash;<router-link to="/admin/orders/bespoke/create" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Create a Bespoke Order</p></router-link>&ndash;&gt;-->
                                        <!--<router-link to="/admin/orders/bespoke" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Search Bespoke Orders</p></router-link>-->
                                        <!--<router-link to="/admin/orders/email" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Search Email Orders</p></router-link>-->
                                        <!--<router-link to="/admin/invoices" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Invoices</p></router-link>-->
                                    <!--</div>-->
                                    <!--<div class="layout__padding-10px-0" id="billing">-->
                                        <!--&lt;!&ndash;<p class="text__size-18 text__colour-teal layout__padding__left-10px">Billing&ndash;&gt;-->
                                        <!--&lt;!&ndash;Admin</p>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<router-link to="/billing/customers" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Search Customers</p></router-link>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<router-link to="/billing/customers/create" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Create Customers</p></router-link>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<router-link to="/billing/orders" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Search Orders</p></router-link>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<router-link to="/billing/invoices" class="link__colour-black"><p&ndash;&gt;-->
                                        <!--&lt;!&ndash;class="component__admin__title">Invoices</p></router-link>&ndash;&gt;-->
                                    <!--</div>-->
                                    <!--<div class="layout__padding-10px-0" id="support">-->
                                        <!--<p class="text__size-18 text__colour-teal layout__padding__left-10px">Order-->
                                            <!--Support</p>-->
                                        <!--<router-link to="/photofixr/upload-orders" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Upload Photofixr Orders</p>-->
                                        <!--</router-link>-->
                                        <!--<router-link to="/photofixr/orders" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Photofixr Orders</p>-->
                                        <!--</router-link>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="component__columns-2__no-padding layout__position-left">-->
                                <!--<div class="layout__padding-0-20">-->
                                    <!--<div class="layout__padding-10px-0" id="insights">-->
                                        <!--<p class="text__size-18 text__colour-teal layout__padding__left-10px">Sales-->
                                            <!--Insights</p>-->
                                        <!--<router-link to="/insights/bespokereports" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Bespoke Reports</p></router-link>-->
                                        <!--<router-link to="/insights/categorysales" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Category Sales</p></router-link>-->
                                        <!--<router-link to="/insights/customersales" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Customer Sales</p></router-link>-->
                                        <!--<router-link to="/insights/customerstatus" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Customer Status</p></router-link>-->
                                        <!--<router-link to="/insights/lapsedcustomers" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Lapsed Customers</p></router-link>-->
                                        <!--<router-link to="/insights/monthendtasks" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Month End Tasks</p></router-link>-->
                                        <!--<router-link to="/insights/newcustomerrevenue" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">New Customer Revenue</p></router-link>-->
                                        <!--<router-link to="/insights/newsales" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">New Sales</p></router-link>-->
                                        <!--<router-link to="/insights/productsales" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Product Sales</p></router-link>-->
                                        <!--<router-link to="/insights/territorysales" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Territory Sales</p></router-link>-->
                                        <!--<router-link to="/insights/totalsales" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Total Sales</p></router-link>-->
                                    <!--</div>-->
                                    <!--<div class="layout__padding-10px-0" id="system">-->
                                        <!--<p class="text__size-18 text__colour-teal layout__padding__left-10px">System-->
                                            <!--Admin</p>-->
                                        <!--<router-link to="/billing/prices/create" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Create Prices</p></router-link>-->
                                        <!--<router-link to="/billing/prices" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Search Prices</p></router-link>-->
                                        <!--<router-link to="/billing/products/create" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Create Products</p></router-link>-->
                                        <!--<router-link to="/billing/products" class="link__colour-black"><p-->
                                                <!--class="component__admin__title">Search Products</p></router-link>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    </div>

                    <div class="layout__position-left layout__padding-0-20">
                        <h4 class="layout__position-left layout__margin__top-20">
                            Hello
                            <span class="text__colour-teal" id="userName"></span>
                        </h4>
                        <div class="" id="switchBranch">
                            <h4 class="layout__position-left">
                                Current Branch
                                <span class="text__colour-teal" id="branch"></span>
                            </h4>
                            <!--<el-button-->
                            <!--class=" button-red button__base__admin layout__margin__left"-->
                            <!--v-on:click="">-->
                            <!--Switch Branch-->
                            <!--</el-button>-->

                        </div>
                        <el-button
                                class=" button-red button__base__admin"
                                v-on:click="switchBranch" id="switch_button">
                            Switch Branch
                        </el-button>
                    </div>
                </div>
                <div class="layout__width-100">

                    <el-dropdown :hide-on-click="true" class="layout__position-left component__navigation-width">
                        <span class="el-dropdown-link">
                            <div class="component__navigation-tab">
                                Products & Services
                            </div>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="layout__padding-clear layout__width-600px layout__margin__left-minus-40 layout__border__all-1px-grey">

                            <div class="layout__width-100">

                                <div class="layout__width-30 layout__position-left">
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100" to="/products/print">
                                            <p class="component__navigation__title layout__border__bottom-1px-dotted-cdcfd1">Print Products</p>
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100"
                                                     to="/products/digital">
                                            <p class="component__navigation__title layout__border__bottom-1px-dotted-cdcfd1">Digital Products</p>
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100"
                                                     to="/products/merchandise">
                                            <p class="component__navigation__title layout__border__bottom-1px-dotted-cdcfd1">Merchandise</p>
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100"
                                                     to="/marketing-toolkit">
                                            <p class="component__navigation__title layout__border__bottom-1px-dotted-cdcfd1">Marketing Toolkit</p>
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100"
                                                     to="/directmailr">
                                            <p class="component__navigation__title layout__border__bottom-1px-dotted-cdcfd1">Directmailr</p>
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100"
                                                     to="/services/land-and-new-homes">
                                            <p class="component__navigation__title layout__border__bottom-1px-dotted-cdcfd1">Land & New Homes</p>
                                        </router-link>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <router-link class="link__colour-black layout__width-100"
                                                     to="/services/design-studio">
                                            <p class="component__navigation__title">Design studio</p>
                                        </router-link>
                                    </el-dropdown-item>
                                </div>

                                <div class="layout__width-70 layout__position-left">
                                    <el-dropdown-item>
                                        <div class="component__forms-2 colour__background-white">
                                            <div class="colour__background-white">
                                                <router-link class="link__colour-black layout__width-100"
                                                             to="/services/door-drops">
                                                    <img class="layout__width-100 colour__background-white layout__position-center"
                                                         src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/flyers.jpg">
                                                    <div class="layout__padding__top-20px">
                                                        <p class="colour__background-white text__align-center text__line-height-15">
                                                            Royal Mail <br>Door Drops</p>
                                                    </div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div class="component__forms-2 colour__background-white">
                                            <div class="colour__background-white">
                                                <router-link class="link__colour-black layout__width-100"
                                                             to="/print/products/document-folders">
                                                    <img class="layout__width-100 colour__background-white layout__position-center"
                                                         src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/Docufolders.jpg">
                                                    <p class="colour__background-white text__align-center layout__padding__top-20px">
                                                        Document Folders</p>
                                                </router-link>
                                            </div>
                                        </div>
                                    </el-dropdown-item>
                                </div>
                            </div>

                        </el-dropdown-menu>
                    </el-dropdown>
                    <router-link to="/photofixr" class="link__colour-teal">
                        <div class="component__navigation-tab component__navigation-width">Photofixr<span
                                class="text__size-8 layout__position-top">TM</span></div>
                    </router-link>
                    <router-link to="/instant-print" class="link__colour-teal" id="instant-print">
                        <div class="component__navigation-tab component__navigation-width">Instant Print</div>
                    </router-link>
                    <router-link to="/about" class="link__colour-teal">
                        <div class="component__navigation-tab component__navigation-width">About Us</div>
                    </router-link>
                    <router-link to="/contact" class="link__colour-teal">
                        <div class="component__navigation-tab component__navigation-width">Contact Us</div>
                    </router-link>
                </div>

            </div>

            <div class="layout__padding-clear layout__width-100 layout__padding-20-0 text__align-center colour__background-b7e3eb font__size-20">
                <!-- RIFAT todo either make it lighter or clash bold and offer teal -->
                Try Photofixr™ for FREE use 'F1XFREE' at the checkout for a FREE basic edit
            </div>

            <!--<router-view/>-->
            <router-view :key="viewKey"></router-view>
            <Footer></Footer>
        </div>

        <el-dialog
                :visible.sync="loginDialog"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="false"
                width="600px">
            <div class="component__login-dialogue layout__padding-clear" v-show="loginDialog">
                <Login></Login>
                <el-button id="closeLogin" class="layout__display-none" v-on:click="loginDialog = false"></el-button>
            </div>
        </el-dialog>

        <el-button class="layout__display-none"
                   id="openLogin" v-on:click="loginDialog = true">Login
        </el-button>

        <el-dialog
                :visible.sync="loginDialogClosable"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="true"
                :before-close="resetForm"
                width="600px">
            <div class="component__login-dialogue layout__padding-clear" v-show="loginDialogClosable">
                <Login ref="loginClosable"></Login>
                <el-button id="loginDialogClosable" class="layout__display-none"
                           v-on:click="loginDialogClosable = false"></el-button>
            </div>
        </el-dialog>

        <!--<el-dialog
                :visible.sync="createAccountDialog"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="true"
                :before-close="resetForm"
                width="600px">
            <div class="component__login-dialogue layout__padding-clear" v-show="createAccountDialog">
                <CreditApplication ref="createAccount"></CreditApplication>
                <el-button id="createAccountDialog" class="layout__display-none"
                           v-on:click="createAccountDialog = false"></el-button>
            </div>
        </el-dialog>-->
        <!--<el-dialog
                :visible.sync="createAccountDialog"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="true"
                width="1100px">
            <div class="component__login-dialogue layout__padding-clear" v-show="createAccountDialog">
                <CreditApplication :account_type="account_type" :payment_method="payment_method" ref="createAccount"></CreditApplication>
                <el-button id="createAccountDialog" class="layout__display-none"
                           v-on:click="createAccountDialog = false"></el-button>
            </div>
        </el-dialog>-->
        <el-dialog
                :visible.sync="createAccountDialog"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="true"
                :before-close="resetAccountForm"
                custom-class="credit-application-dialog">
            <div class="component__login-dialogue layout__padding-clear" v-show="createAccountDialog">
                <CreditApplication v-on:closeAccount="createAccountDialog = false" account_type="ACCOUNT" payment_method="MONTHLYEMAILINVOICE" ref="createAccount"></CreditApplication>
                <el-button id="createAccountDialog" class="layout__display-none"
                           v-on:click="createAccountDialog = false"></el-button>
            </div>
        </el-dialog>
        <el-dialog
                :visible.sync="createPAYGDialog"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                :show-close="true"
                :before-close="resetPAYGForm"
                custom-class="credit-application-dialog">
            <div class="component__login-dialogue layout__padding-clear" v-show="createPAYGDialog">
                <CreditApplication v-on:closePAYG="createPAYGDialog = false" account_type="PAYG" payment_method="PAYGEMAILINVOICE" ref="createPAYG"></CreditApplication>
                <el-button id="createPAYGDialog" class="layout__display-none"
                           v-on:click="createPAYGDialog = false"></el-button>
            </div>
        </el-dialog>


        <el-button class="layout__display-none"
                   id="openCreateAccount" v-on:click="createAccountDialog = true">Create Account
        </el-button>
        <el-button class="layout__display-none"
                   id="openCreatePAYG" v-on:click="createPAYGDialog = true">Create PAYG
        </el-button>

        <div class="layout__display-none layout__margin__bottom-25px" id="activeOrders">
            <div class="rifat-test-transition">
                <div class="layout__width-40 text__align-center">
                    <img class="layout__width-50" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/shopping-cart.svg"/>
                </div>
                <div class="">
                    <div class="layout__position-right text__align-right el-icon-close text__size-24 layout__cursor-pointer"
                         v-on:click="closeActiveOrders()"></div>
                    <div class="layout__position-left">
                        <h3 class="layout__margin__top-10 text__colour-red">You have orders in your basket</h3>
                        <div class="">

                            <p class="layout__padding-5 text__colour-grey layout__padding-clear text__size-16">View your basket to edit and order these items or alternatively you can remove all orders from your basket.</p>
                        </div>

                        <el-button
                                class="button__base button-teal layout__display-block text__align-center layout__cursor-pointer layout__margin-20-0"
                                v-on:click="viewBasket()">View items in your basket
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters, mapActions} from 'vuex';
    import Element from 'element-ui';
    import Footer from './components/Footer.vue';
    import Basket from './components/customer/Basket.vue';
    import Login from './views/Login.vue';
    import Axios from 'axios';
    import Router from './router.js';
    import EventBus from './EventBus.js';
    import {axios} from './mixins/Axios.js';
    import {backing} from './mixins/Backing.js';
    import JsonExcel from 'vue-json-excel';
    import CreditApplication from './views/CreditApplication.vue';

    import lang from 'element-ui/lib/locale/lang/en'
    import locale from 'element-ui/lib/locale'

    locale.use(lang)

    Vue.use(Element, locale);
    Vue.component('downloadExcel', JsonExcel)

    export default {
        name: "App",
        mixins: [axios, backing],
        components: {
            Basket,
            Footer,
            Login,
            CreditApplication
        },
        data() {
            return {
                userRole: [],
                loginDialog: false,
                loginDialogClosable: false,
                createAccountDialog: false,
                createPAYGDialog: false,
                versionUri: `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/maintenance/currentversion?ravProjectName=myrav&ravTier=frontend`,
                multi_branch: false,
                account_type: '',
                payment_method: '',
                viewKey: 1,
                warningText: '',
            }
        },
        computed: {
            ...mapGetters(
                ['getPhotofixrTotal', 'getOrderTotal', 'getInstantPrintTotal'])
        },
        mounted() {
            this.userRole = JSON.parse(window.sessionStorage.getItem('_role'));
            document.getElementById("orders").style.display = "none";
            document.getElementById("billing").style.display = "none";
            document.getElementById("insights").style.display = "none";
            document.getElementById("system").style.display = "none";
            document.getElementById("support").style.display = "none";
            document.getElementById("switch_button").style.display = "none";
            document.getElementById("switchBranch").style.display = 'none';
            document.getElementById("userManagement").style.display = "none";

            if (this.returnCookie('_token') !== null) {
                document.getElementById('alreadyloggedin').style.display = "block";
                document.getElementById('mustlogin').style.display = "none";
                document.getElementById("userName").innerText = this.returnCookie('_customerName')
                document.getElementById("myAccount").style.display = "block";
            } else {
                document.getElementById('alreadyloggedin').style.display = "none";
                document.getElementById('mustlogin').style.display = "block";
                document.getElementById("myAccount").style.display = "none";

                if (this.$route.name !== '/forgot-password' && this.$route.name !== '/') {
                }
            }

            console.log('session customer ', this.returnCookie('_customer'))

            // if (this.returnCookie('_customer') === null) {
            //     document.getElementById("switchBranch").display = "none";
            // } else {
            //     document.getElementById("switchBranch").display = "block";
            //     document.getElementById("branch").innerText = JSON.parse(this.returnCookie('_customer')).ref
            // }

            if (this.userRole === null) {
                document.getElementById("admin").style.display = "none";
            } else {
                if (this.userRole.includes('Customer') || this.userRole.includes('AccountCustomer')) {
                    document.getElementById("admin").style.display = "none";

                    if (window.sessionStorage.getItem('_membershipCount') > 1) {
                        document.getElementById("branch").innerText = JSON.parse(window.sessionStorage.getItem('_customer')).branchName + ' (' + JSON.parse(window.sessionStorage.getItem('_customer')).ref + ')'
                        document.getElementById("switch_button").style.display = "block";
                        document.getElementById("switchBranch").style.display = 'block';
                    }

                } else {
                    document.getElementById("admin").style.display = "block";
                    document.getElementById("branch").innerText = 'INTERNAL USER'
                    if (this.userRole.includes('RpsAdministrator')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("billing").style.display = "block";
                        document.getElementById("insights").style.display = "block";
                        document.getElementById("system").style.display = "block";
                        document.getElementById("support").style.display = "block";
                        document.getElementById("userManagement").style.display = "block";
                    } else if (this.userRole.includes('RpsManager')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("billing").style.display = "block";
                        document.getElementById("insights").style.display = "block";
                    } else if (this.userRole.includes('RpsTeamLeader')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("billing").style.display = "block";
                        document.getElementById("insights").style.display = "block";
                        document.getElementById("support").style.display = "block";
                    } else if (this.userRole.includes('RpsUser')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("support").style.display = "block";
                    } else if (this.userRole.includes('RpsSales')) {
                        document.getElementById("insights").style.display = "block";
                    } else if (this.userRole.includes('RpsBilling')) {
                        document.getElementById("billing").style.display = "block";
                    } else if (this.userRole.includes('PhotoEditor')) {
                        document.getElementById("support").style.display = "block";
                        document.getElementById("myAccount").style.display = "none";
                    }
                }
            }

            //    todo - Rifat running the reload method every 60 minutes
            window.setInterval(() => {
                // window.sessionStorage.setItem("_myRavensworthVersion", this.version)

                const getVersion = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/maintenance/currentversion?ravProjectName=myrav&ravTier=frontend`

                Axios.get(getVersion)
                    .then(response => {
                        this.warningText = response.data.warningText;
                        console.log('printing version response')
                        if (response.data.version !== window.sessionStorage.getItem("_myRavensworthVersion")) {
                            window.location.reload(true);
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }, 3600000);

            // create listeners
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
            var _this = this;

            eventer(messageEvent, function (e) {
                if (e.data == 'OpenLiveChat') {
                    $zopim.livechat.window.show();
                }

                if (e.data == 'ScrollIntoView') {
                    window.scrollTo(0, 0);
                }

                if (e.data == 'InstantMarketingHome') {
                    Router.push({
                        name: '/directmailr'
                    });
                }

                try {
                    if (e.data.includes('StoreDMOrder')) {
                        var dataArray = e.data.split(':');
                        console.log('_dm_order_id=' + dataArray[1]);
                        window.sessionStorage.setItem('_dm_order_id', dataArray[1]);

                        const basketTotals = {
                            directmailr: 1
                        }

                        _this.$store.dispatch("incrementPhotofixrTotal", basketTotals);
                    }
                }
                catch(err) {
                    // console.log(err);
                }

                if (e.data == 'ClearDMOrder') {
                    window.sessionStorage.removeItem('_dm_order_id');

                    const basketTotals = {
                        directmailr: 0
                    }

                    _this.$store.dispatch("incrementPhotofixrTotal", basketTotals);
                }
            }, false);
        },
        beforeCreate() {
            const version = `${process.env.VUE_APP_VERSIONNUMBER}`
            window.sessionStorage.setItem("_myRavensworthVersion", version)

            const getVersion = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/maintenance/currentversion?ravProjectName=myrav&ravTier=frontend`

            console.log(getVersion)

            Axios.get(getVersion)
                .then(response => {
                    this.warningText = response.data.warningText;
                    console.log('printing version response')
                    if (response.data.version !== window.sessionStorage.getItem("_myRavensworthVersion")) {
                        console.log('reload')
                        window.location.reload(true);
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        created() {

            // if (!window._laq) { window._laq = []; }
            // window._laq.push(function(){liveagent.showWhenOnline('5731X00000000KE', document.getElementById('liveagent_button_online_5731X00000000KE'));
            //     liveagent.showWhenOffline('5731X00000000KE', document.getElementById('liveagent_button_offline_5731X00000000KE'));
            // });


            this.userRole = JSON.parse(window.sessionStorage.getItem('_role'));

            EventBus.$on('update', function (_token, _customerName, _role, _branch) {
                console.log('in the update event', _branch)
                if (_token === null) {
                    document.getElementById('mustlogin').style.display = "block";
                    document.getElementById('alreadyloggedin').style.display = "none";
                    document.getElementById("myAccount").style.display = "none";
                    // document.getElementById("switchBranch").style.display = "none";
                } else {
                    document.getElementById("userName").innerText = _customerName
                    document.getElementById('mustlogin').style.display = "none";
                    document.getElementById('alreadyloggedin').style.display = "block";
                    document.getElementById("myAccount").style.display = "block";
                }

                console.log('branch ', _branch)
                console.log(typeof _branch === undefined)

                // if (typeof _branch === undefined) {
                //     document.getElementById("switchBranch").display = "none";
                // } else {
                //     document.getElementById("switchBranch").display = "block";
                //     document.getElementById("branch").innerText = JSON.parse(_branch).ref
                // }

                if (_role.includes('Customer') || _role.includes('AccountCustomer')) {
                    document.getElementById("admin").style.display = "none";

                    if (window.sessionStorage.getItem('_membershipCount') > 1) {
                        document.getElementById("branch").innerText = JSON.parse(_branch).branchName + ' (' + JSON.parse(_branch).ref + ')'
                        document.getElementById("switch_button").style.display = "block";
                        document.getElementById("switchBranch").style.display = 'block';
                    }
                } else {
                    document.getElementById("admin").style.display = "block";
                    document.getElementById("branch").innerText = 'INTERNAL USER'
                    if (_role.includes('RpsAdministrator')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("billing").style.display = "block";
                        document.getElementById("insights").style.display = "block";
                        document.getElementById("system").style.display = "block";
                        document.getElementById("support").style.display = "block";
                        document.getElementById("userManagement").style.display = "block";
                    } else if (_role.includes('RpsManager')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("billing").style.display = "block";
                        document.getElementById("insights").style.display = "block";
                    } else if (_role.includes('RpsTeamLeader')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("billing").style.display = "block";
                        document.getElementById("insights").style.display = "block";
                        document.getElementById("support").style.display = "block";
                    } else if (_role.includes('RpsUser')) {
                        document.getElementById("orders").style.display = "block";
                        document.getElementById("support").style.display = "block";
                    } else if (_role.includes('RpsSales')) {
                        document.getElementById("insights").style.display = "block";
                    } else if (_role.includes('RpsBilling')) {
                        document.getElementById("billing").style.display = "block";
                    } else if (_role.includes('PhotoEditor')) {
                        document.getElementById("support").style.display = "block";
                        document.getElementById("myAccount").style.display = "none";
                    }
                }

                var emailAddress = window.sessionStorage.getItem('_emailAddress');
                console.log('emailAddress: ' + emailAddress);
                console.log('emailAddress (regex): ' + /^.*@leaders.*$/.test(emailAddress));
                if (/^.*@leaders.*$/.test(emailAddress)) {
                    document.getElementById("instant-print").style.display = "none";
                } else {
                    document.getElementById("instant-print").style.display = "block";
                }

            })


            EventBus.$on('activeOrders', function () {
                console.log('=========== popping up the login ============')
                if (window.sessionStorage.getItem('_activeOrders') !== null && JSON.parse(window.sessionStorage.getItem('_activeOrders')) !== '1') {
                    document.getElementById("activeOrders").style.display = "block";
                }
            })


            EventBus.$on('login', function () {
                document.getElementById('openLogin').click();
            })


            EventBus.$on('createAccount', function (accountType, paymentMethod) {
                console.log('createAccount - accountType=' + accountType + ', paymentMethod=' + paymentMethod);

                if (accountType == 'ACCOUNT') {
                    document.getElementById('openCreateAccount').click();
                } else {
                    document.getElementById('openCreatePAYG').click();
                }
            })

        },
        methods: {
            ...mapActions([
                'increment',
                'decrement',
                'incrementIfOdd',
                'incrementAsync'
            ]),
            openLogin() {
                console.log('clicking register')
                this.ravensworth = true;
            },
            logoutUser() {
                this.clearUserSession()
            },
            viewBasket() {

                this.closeActiveOrders()

                Router.push({
                    name: '/basket'
                });
            },
            // removeAllActiveOrders() {
            //     this.closeActiveOrders()
            //
            //     const basketTotals = {
            //         photofixr: 0,
            //         instantPrint: 0
            //     }
            //
            //     this.$store.dispatch("incrementPhotofixrTotal", basketTotals)
            //
            //
            //     window.sessionStorage.removeItem('_jobId');
            //     window.sessionStorage.removeItem('_fixes');
            //     window.sessionStorage.removeItem('_uploadedOrders');
            //     window.sessionStorage.removeItem('_branchCode');
            //     window.sessionStorage.removeItem('_filename');
            //     window.sessionStorage.removeItem('_reference');
            //     window.sessionStorage.removeItem('_propertyName');
            //     window.sessionStorage.removeItem('_printJob');
            //     window.sessionStorage.removeItem('_source');
            //
            //     const clearActiveOrders = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/ClearActiveOrders?userId=` + window.sessionStorage.getItem('_userId') + '&customerRef=' + JSON.parse(window.sessionStorage.getItem('_customer')).ref
            //
            //     Axios.post(clearActiveOrders, {}, this.returnHeaderUsingToken())
            //         .then(response => {
            //             console.log(response)
            //             window.sessionStorage.removeItem('_activeOrders')
            //             if (response) {
            //                 this.$message({
            //                     message: 'All active orders have been removed',
            //                     type: 'success'
            //                 });
            //             }
            //         })
            // },
            closeActiveOrders() {
                document.getElementById("activeOrders").style.display = "none";
            },
            resetForm() {
                console.log('resetForm');
                this.$refs.loginClosable.resetAndCloseDialog();
            },
            resetAccountForm(done) {
                this.$refs.createAccount.resetForm();
                done();
            },
            resetPAYGForm(done) {
                this.$refs.createPAYG.resetForm();
                done();
            },
            switchBranch() {
                Router.push({
                    name: '/account/switch-branch'
                });
            },
            openLoginDialog() {
                this.loginDialogClosable = true;

                global.vm.$children[0].loginDialogClosable = true;
                Vue.nextTick(function () {
                    global.vm.$children[0].$refs.loginClosable.activeForm = 'login';
                })
            },
            showProfile() {
                console.log('showProfile click');

                this.viewKey += 1;
                window.sessionStorage.setItem('_showProfile', true);

                Router.push({
                    name: '/directmailr/place-order'
                });
            },
            showTemplates() {
                console.log('showTemplates click');

                this.viewKey += 1;
                window.sessionStorage.setItem('_showTemplates', true);

                Router.push({
                    name: '/directmailr/place-order'
                });
            }
        }
    };
</script>
